import { createFileRoute } from '@tanstack/react-router'
import UserClaims from 'User/components/Sections/UserClaims'

export const Route = createFileRoute('/user/$userId/claims')({
    component: UserClaims,
})
